import type { ReactNode } from 'react';
import type { SizeScale } from '@pv-frontend/design-tokens';
import { Box } from '../box/box';

export interface CardProps {
    children?: ReactNode;
    padding?: SizeScale;
    /** Elevation preset (default `soft`). */
    shadow?: 'card' | 'overlay' | 'soft';
    testID?: string;
}

/** Resting surface — a bordered, rounded, subtly-elevated card. */
export function Card({ children, padding = '400', shadow = 'soft', testID }: CardProps) {
    return (
        <Box
            background="bg-card"
            borderColor="border-card"
            borderWidth="0165"
            borderRadius="300"
            padding={padding}
            shadow={shadow}
            testID={testID}
        >
            {children}
        </Box>
    );
}
